<template>
  <div class="report-wrapper">
    <div class="report-header">
      <app-btn @click="goBack()">{{$ml.get('Back')}}</app-btn>
    </div>
    <div class="report">
      <div class="soil-test">
    <div class="html2pdf__page-break">
      <MainHeader>
        {{$ml.get('Soil test')}}
      </MainHeader>
      
      <GeneralInfo/>
      <Parameters/>
      <Interpretations/>
    </div>
    <div class="html2pdf__page-break">
      <NutChart/>
    </div>    
  </div>
    </div>
  </div>
</template>

<script>
import GeneralInfo from './reports/soil/GeneralInfo';
import NutChart from './reports/soil/NutChart';
import Interpretations from './reports/soil/Interpretations';
import Parameters from './reports/soil/Parameters';
import MainHeader from './reports/common/MainHeader';

import { mapGetters } from 'vuex'

export default {
  components: {
    GeneralInfo,
    Interpretations,
    Parameters,
    MainHeader,
    NutChart,
  },
  methods: {
    
    goBack() {
      this.$store.commit('pdf/removeData');
      this.$router.go(-1);
    }
  },
  beforeMount() {
    this.$root.data = this.data;
    console.log(this.$root.data)
  },
  mounted() {
    console.log(Object.keys(this.data).length)
    if(Object.keys(this.data).length === 0) {
      this.$router.push('/')
    }
  },
  computed: {
    ...mapGetters({
      data: 'pdf/data'
    })
  }
}
</script>

<style lang="scss" scoped>

.soil-test {
  .head-line {
    margin-bottom: 10px;
  }
}
#report {
  font-family: 'Lato';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  > * {
    display: block;
    page-break-before: always;
  }
}
.report {
  width: 100%;
  margin: 0 auto;
  background: #fff;
  flex-direction: column;
  overflow-x: hidden;
  padding: 20px;
}
.report-wrapper {
  display: flex;
  flex-direction: column;
}
.report-header {
  padding: 23px 0 27px;
}
.section {
  padding: 30px;
}

</style>